<template>
  <div class="mt-0 pr-15" style="overflow-x: hidden;">
    <div class="pv-5">
      <el-row class="mt-10 align-center flex">
        <el-col :span="6">
          <span class="mr-10">Time zone</span>
        </el-col>
        <el-col :span="18" class="text-right">
          <dads-select
            v-model="timezone"
            placeholder="Select time zone"
            @change="updateTimezone"
            filterable
          >
            <template slot="prefix">
              Time zone
            </template>
            <el-option
              v-for="(item, index) in timezoneOptions"
              :key="index"
              :label="item.name"
              :value="item.name"
            />
          </dads-select>
        </el-col>
      </el-row>
    </div>
    <hr />
    <div class="pv-20">
      <el-row class="mt-0">
        <el-col :span="6">
          <span class="mr-10">Dark mode</span>
        </el-col>
        <el-col :span="18" class="text-right">
          <el-switch
            :value="colorMode"
            @change="toggleMode"
            active-color="#35be8b"
            inactive-color="#ff8f02"
          >
          </el-switch>
        </el-col>
      </el-row>
    </div>
    <hr />
    <div class="pv-20">
      <el-row class="mt-10">
        <el-col :span="6">
          <span class="mr-5">Incoming calls</span>
          <el-popover trigger="hover" width="300px" placement="bottom">
            <i class="more-info-icon el-icon-question" slot="reference" />
            <span class="black-text">
              Enables push notifications for incoming calls
            </span>
          </el-popover>
        </el-col>
        <el-col :span="18" class="text-right">
          <el-switch
            :value="enableCallNotifications"
            @change="toggleEnableCallNotifications"
            active-color="#35be8b"
            inactive-color="#f25a6b"
          />
        </el-col>
      </el-row>
      <!--      <el-row class="mt-10" :gutter="20">
        <el-col :span="6">
          <span class="mr-10">Chat</span>
        </el-col>
        <el-col :span="18" class="text-right">
          <el-switch
            :value="enableChatNotifications"
            :disabled="true"
            @change="toggleEnableChatNotifications"
            active-color="#35be8b"
            inactive-color="#f25a6b">
          </el-switch>
        </el-col>
      </el-row>-->
      <hr class="mt-30" />
      <el-row class="mt-10 pv-20">
        <el-col :span="6">
          <span class="mr-5">Headset controls (Plantronics)</span>
          <el-popover trigger="hover" width="300px" placement="bottom">
            <i class="more-info-icon el-icon-question" slot="reference" />
            <span class="black-text" style="max-width: 200px;">
              Requires
              <a href="https://www.poly.com/us/en/support/downloads-apps/hub-desktop" target="blank">
                plantronics hub
              </a>
              software to be installed and running
            </span>
          </el-popover>
        </el-col>
        <el-col :span="18" class="text-right">
          <el-switch
            v-model="plantronicsEnabled"
            active-color="#35be8b"
            inactive-color="#f25a6b"
          />
        </el-col>
      </el-row>
      <hr />
      <el-row class="mt-10 flex align-center" :gutter="20">
        <el-col :span="20">
          <span class="mr-10">Incoming ring tone</span>
        </el-col>
        <el-col :span="8" class="text-right">
          <dads-select
            v-model="incomingRingTone"
            placeholder="Select incoming ring tone"
          >
            <template slot="prefix">
              Incoming ring tone
            </template>
            <el-option
              v-for="item in allRingToneOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </dads-select>
          <audio id="incomingRingToneAudio">
            <source
              src="https://global-app.s3.amazonaws.com/omnia-assets/ringtones/10.mp3"
              type="audio/mpeg"
            />
          </audio>
        </el-col>
      </el-row>
      <hr />
      <div class="pb-20">
        <el-row>
          <el-row class="mt-20" :gutter="20">
            <el-col :span="6">
              <span class="mr-10">Incoming ring</span>
            </el-col>
            <el-col :span="18" class="text-right">
              <el-slider
                v-model="inboundRingVolume"
                class="preferences-slider"
              />
            </el-col>
          </el-row>
          <el-row class="mt-5" :gutter="20">
            <el-col :span="6">
              <span class="mr-10">Outbound ring</span>
            </el-col>
            <el-col :span="18" class="text-right">
              <el-slider
                v-model="outboundRingVolume"
                class="preferences-slider"
              />
            </el-col>
          </el-row>
          <el-row class="mt-5" :gutter="20">
            <el-col :span="6">
              <span class="mr-10">Call waiting notify</span>
            </el-col>
            <el-col :span="18" class="text-right">
              <el-slider
                v-model="callWaitingVolume"
                class="preferences-slider"
              />
            </el-col>
          </el-row>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import feathersClient from "../../../../feathers/feathers-client";
import moment from "moment-timezone";
import DadsSelect from "@/components/select";

export default {
  name: "UserSettings",
  props: {
    timezoneOptions: { required: true }
  },
  components: { DadsSelect },
  data() {
    return {
      pushEnabled: false,
      enableCallNotifications: false,
      enableChatNotifications: false,
      timezone: null,
      incomingRingToneOptions: [
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/10.mp3",
          label: "Tranquility"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/2.mp3",
          label: "Buzz"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/3.mp3",
          label: "Skipe"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/4.mp3",
          label: "Chimes"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/5.mp3",
          label: "Submerged"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/6.mp3",
          label: "Woody"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/7.mp3",
          label: "Hopscotch"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/8.mp3",
          label: "Interstellar"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/9.mp3",
          label: "Agency"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/1.mp3",
          label: "Hotel"
        }
      ],
      superAdminIncomingRingToneOptions: [
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/Lorna.mp3",
          label: "Lorna Shore!"
        },
        {
          value: "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/ambuhlance.mp3",
          label: "Ambuhlance"
        }
      ]
    };
  },
  computed: {
    colorMode() {
      return this.$store.state.layout.theme === "theme-dark";
    },
    user() {
      return this.$store.state.auth.user;
    },
    allRingToneOptions () {
      return this.isSuperAdmin ? [...this.incomingRingToneOptions, ...this.superAdminIncomingRingToneOptions] : this.incomingRingToneOptions;
    },
    incomingRingTone: {
      get: function() {
        return this.$store.state.incomingRingTone;
      },
      set: function(val) {
        this.$store.commit("setIncomingRingTone", val);
        let incomingRingToneAudio = document.getElementById(
          "incomingRingToneAudio"
        );
        incomingRingToneAudio.src = val;
        incomingRingToneAudio.volume = this.inboundRingVolume / 100;
        incomingRingToneAudio.play();
      }
    },
    inboundRingVolume: {
      get: function() {
        return this.$store.state.inboundRingVolume * 100;
      },
      set: function(val) {
        this.$store.commit("setInboundRingVolume", val);
      }
    },
    outboundRingVolume: {
      get: function() {
        return Math.round(this.$store.state.outboundRingVolume * 100);
      },
      set: function(val) {
        this.$store.commit("setOutboundRingVolume", val);
      }
    },
    callWaitingVolume: {
      get: function() {
        return Math.round(this.$store.state.callWaitingVolume * 100);
      },
      set: function(val) {
        this.$store.commit("setCallWaitingVolume", val);
      }
    },
    plantronicsEnabled: {
      get: function() {
        return this.$store.state.plantronicsEnabled;
      },
      set: function(val) {
        this.$store.commit('setPlantronicsEnabled', val)
      }
    },
    isSuperAdmin() {
      if (this.user) {
        return +this.user.userRole === 1;
      }
    }
  },
  watch: {
    userPushEnabled() {
      this.pushEnabled = !!this.userPushEnabled;
    }
  },
  methods: {
    toggleMode() {
      const body = document.body;
      const currentClass = body.className;
      const newTheme =
        currentClass === "theme-dark" ? "theme-default" : "theme-dark";
      body.className = newTheme;
      this.$store.commit("setTheme", newTheme);
    },
    async toggleEnableCallNotifications() {
      // console.log('toggle enable call');

      //make sure we have the latest copy of the user before updating
      const currentUser = await feathersClient.service('users').get(this.user.id);
      this.$store.commit('auth/setUser', currentUser);

      this.enableCallNotifications = !this.enableCallNotifications;
      const {
        email,
        receiveQueueReports,
        receiveQueueUserReports,
        tenantId,
        userRole,
        tenantIds,
        adminQueues,
        partnerId
      } = this.user;
      feathersClient
        .service("users")
        .patch(this.user.id, {
          email,
          extension: this.user.myExtension.number,
          receiveQueueReports,
          receiveQueueUserReports,
          resetPassword: false,
          tenantId,
          tenantIds,
          adminQueues,
          userRole,
          enableCallNotifications: this.enableCallNotifications,
          timezone: this.timezone,
          partnerId
        })
        .then(() => {
          let currentUser = { ...this.user };
          currentUser.enableCallNotifications = this.enableCallNotifications
            ? 1
            : 0;
          this.$store.commit("auth/setUser", currentUser);

					if(this.enableCallNotifications) {
						// ⭐️ `Call Notifications Enabled` user event log ⭐️ //
						this.$store.dispatch('userEvents/create', {
							event: "Enable Call Push Notifications",
						});
					} else {
						// ⭐️ `Call Notifications Disabled` user event log ⭐️ //
						this.$store.dispatch('userEvents/create', {
							event: "Disable Call Push Notifications",
						});
					}
        });
    },
    async toggleEnableChatNotifications() {
      // console.log('toggle enable chat');

      //make sure we have the latest copy of the user before updating
      const currentUser = await feathersClient.service('users').get(this.user.id);
      this.$store.commit('auth/setUser', currentUser);

      this.enableChatNotifications = !this.enableChatNotifications;
      const {
        email,
        receiveQueueReports,
        tenantId,
        userRole,
        tenantIds,
        adminQueues,
        partnerId,
        receiveQueueUserReports
      } = this.user;
      feathersClient
        .service("users")
        .patch(this.user.id, {
          email,
          extension: this.user.myExtension.number,
          receiveQueueReports,
          receiveQueueUserReports,
          resetPassword: false,
          tenantId,
          tenantIds,
          adminQueues,
          userRole,
          enableChatNotifications: this.enableChatNotifications,
          timezone: this.timezone,
          partnerId
        })
        .then(() => {
          let currentUser = { ...this.user };
          currentUser.enableChatNotifications = this.enableChatNotifications
            ? 1
            : 0;
          this.$store.commit("auth/setUser", currentUser);
        });
    },
    async updateTimezone() {

      //make sure we have the latest copy of the user before updating
      const currentUser = await feathersClient.service('users').get(this.user.id);
      this.$store.commit('auth/setUser', currentUser);

      if (this.user.timezone !== this.timezone) {
        // console.log('update the time zone');
        const {
          email,
          receiveQueueReports,
          receiveQueueUserReports,
          tenantId,
          userRole,
          tenantIds,
          adminQueues,
          partnerId
        } = this.user;
        feathersClient
          .service("users")
          .patch(this.user.id, {
            email,
            extension: this.user.myExtension.number,
            receiveQueueReports,
            receiveQueueUserReports,
            resetPassword: false,
            tenantId,
            tenantIds,
            adminQueues,
            userRole,
            timezone: this.timezone,
            partnerId
          })
          .then(() => {
            let currentUser = { ...this.user };
            currentUser.timezone = this.timezone;
            this.$store.commit("auth/setUser", currentUser);
            const offsetUTCServer = moment.tz("America/Chicago").utcOffset();
            const offsetMe = moment.tz(this.timezone).utcOffset();
            const userOffset = offsetMe - offsetUTCServer;
            this.$store.commit("setUserTimeOffset", userOffset);

						// ⭐️ `Update Timezone` user event log ⭐️ //
						this.$store.dispatch('userEvents/create', {
							event: "Update Timezone",
							timezone: this.timezone,
						});
          });
      }
    }
  },
  mounted() {
    if (this.user) {
      this.enableChatNotifications = this.user.enableChatNotifications === 1;
      this.enableCallNotifications = this.user.enableCallNotifications === 1;
      this.enableChatNotifications = this.user.enableChatNotifications === 1;
      this.enableCallNotifications = this.user.enableCallNotifications === 1;
      this.timezone = this.user.timezone;
    }
  }
};
</script>

<style lang="scss" scoped>
.preferences-header {
  font: {
    weight: bold;
    size: 13pt;
  }
}

.integration-select {
  max-width: 300px;
  margin-right: 0;
}

.el-select {
  margin-top: 0;
  margin-bottom: 0;
  margin-left: auto;
  margin-right: 0;
  width: 350px;
}
</style>
